/**
 * Wire-mapping: this app's hand-written snake_case `AccessRequest` (the
 * shape `accessRequestsClient.ts` already deep-snake-converts every
 * response into — see that file's own doc comment) -> the camelCase
 * `AccessRequest` shape @devnw/cyber-iam's iam/AccessRequestList,
 * iam/AccessRequestDetailPanel and iam/GrantActivationPanel render
 * (OIDCPAM Gate-6 Phase 5a).
 *
 * Every date/time field on the library's shape is documented as a
 * "pre-formatted display string (host formats)" — this app's pre-migration
 * MUI pages rendered the wire's raw RFC3339 strings unchanged (no
 * formatting), so passing them straight through here preserves that exact
 * existing behavior rather than introducing new display formatting.
 */
import type { AccessRequest as IamAccessRequest } from '@devnw/cyber-iam/iam/types'
import type { AccessRequest as WireAccessRequest } from './types'

export function toIamAccessRequest(req: WireAccessRequest): IamAccessRequest {
  return {
    id: req.id,
    subjectId: req.subject_id,
    resourceId: req.resource_id,
    purpose: req.purpose,
    status: req.status,
    justification: req.justification,
    actions: req.actions,
    permissions: req.permissions,
    ticketRef: req.ticket_ref
      ? { system: req.ticket_ref.system, externalId: req.ticket_ref.external_id }
      : undefined,
    requestedDurationSeconds: req.requested_duration_seconds,
    denialReason: req.denial_reason,
    createdAt: req.created_at,
    activatedAt: req.activated_at,
    expiresAt: req.expires_at,
  }
}
